<template>
  <div id="contact-edit">
    <div class="title" v-if="form.id === 0">New Contact Person</div>
    <div class="title" v-else>{{ form.name }}</div>
    <table>
      <tr>
        <td class="label">First Name</td>
        <td style="width:350px"><el-input v-model="form.first_name" style="width:200px"></el-input></td>
        <td class="label">Last Name</td>
        <td>
          <select v-model="form.respect" style="width:50px">
            <option value="">--</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
          </select>
          <el-input v-model="form.last_name" style="width:200px"></el-input>
        </td>
      </tr> 
      <tr>
        <td class="label">Department</td>
        <td colspan="3"><el-input v-model="form.department" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Job Title</td>
        <td><el-input v-model="form.job_title" style="width:200px"></el-input></td>
        <td colspan="2">
          <el-checkbox v-model="form.is_key" true-label="1" false-label="0">Key</el-checkbox>
        </td>
      </tr> 
      <tr>
        <td class="label">Tel</td>
        <td><el-input v-model="form.phone" style="width:200px"></el-input></td>
        <td class="label">Fax</td>
        <td><el-input v-model="form.fax" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Mobile</td>
        <td><el-input v-model="form.mobile" style="width:200px"></el-input></td>
        <td class="label">MSN</td>
        <td><el-input v-model="form.msn" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Email 1</td>
        <td><el-input v-model="form.email" style="width:200px"></el-input></td>
        <td class="label">Email 2</td>
        <td><el-input v-model="form.email_2" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Wechat</td>
        <td><el-input v-model="form.wechat" style="width:200px"></el-input></td>
        <td class="label">QQ</td>
        <td><el-input v-model="form.qq" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">WhatsApp</td>
        <td><el-input v-model="form.whatsapp" style="width:200px"></el-input></td>
        <td class="label">Facebook</td>
        <td><el-input v-model="form.facebook" style="width:200px"></el-input></td>
      </tr> 
      <tr>
        <td class="label">Skype</td>
        <td><el-input v-model="form.skype" style="width:200px"></el-input></td>
        <td class="label">Status</td>
        <td>
          <select v-model="form.status">
            <option value="In-service">In-service</option>
            <option value="Dimission">Dimission</option>
          </select>
        </td>
      </tr> 
      <tr>
        <td class="label">Notes</td>
        <td><el-input type="textarea" v-model="form.remark"></el-input></td>
        <td colspan="2" style="text-align:right;vertical-align: bottom;">
          Create by {{ contact.create_oper_name }} at {{ contact.create_time }} <br/>
          Modified by {{ contact.update_oper_name }} at {{ contact.update_time }}
        </td>
      </tr> 
      <tr>
        <td colspan="4" style="text-align:right;padding:6px;">
          <el-button @click="save">Save</el-button>
          <el-button @click="cancel">Cancel</el-button>
          <el-button type="danger" @click="del" v-if="user.role_id < 3 && form.id > 0">Delete</el-button>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      contact: {
        id: this.$route.params.contact_id === 'new' ? 0 : parseInt(this.$route.params.contact_id),
        name: ''
      },
      form: {
        id: this.$route.params.contact_id === 'new' ? 0 : parseInt(this.$route.params.contact_id),
        company_id: parseInt(this.$route.params.id),
        name: '',
        first_name: '',
        last_name: '',
        respect: '',
        language: 'English',
        department: '',
        job_title: '',
        is_key: '0',
        phone: '',
        phone_2: '',
        fax: '',
        fax_2: '',
        email: '',
        email_2: '',
        mobile: '',
        msn: '',
        qq: '',
        wechat: '',
        whatsapp: '',
        facebook: '',
        skype: '',
        status: 'In-service',
        remark: ''
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    if (this.$route.params.contact_id !== 'new') {
      this.fetchContact()
    }
  },
  methods: {
    fetchContact () {
      this.$http.get('/dbapi/company_contact_list?id=' + this.$route.params.contact_id).then(data => {
        if (data.list.length > 0) {
          this.contact = data.list[0]
          this.form = { ...this.contact }
        }
      })
    },
    save () {
      let url = '/dbapi/contact_insert'
      if (this.form.id > 0) {
        url = '/dbapi/contact_update'
      }
      this.form.name = this.form.first_name + ' ' + this.form.last_name
      this.$http.post(url, this.form).then(data => {
        this.$router.push('/customer/company/' + this.form.company_id)
      })
    },
    del () {
      this.$confirm('Delete?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/contact_del', { id: this.$route.params.contact_id }).then(data => {
          this.$message({
            type: 'success',
            message: 'Deleted.'
          })
          this.$router.push('/customer/company/' + this.form.company_id)
        })
      })
    },
    cancel () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
#contact-edit {
  background: #ffffeb;
  font-size: 14px;
  padding-right: 10px;
  .title {
    background: #2a82ff;
    font-size: 14px;
    font-weight: bold;
    padding: 4px;
    color: #ffffff;
  }
  table {
  width: 100%;
  border-spacing: 0;
  background-color: #ffffeb;
  border-right: 1px solid #c3c3c2;
    td {
      border-bottom: 1px solid #c3c3c2;
      padding: 2px 4px;
    }
    td.label {
      width: 120px;
      background-color: #eaebd5;
    }
  }
  .el-input__inner {
    padding: 0 5px;
  }
}
</style>

